import React from "react"
import ActivityBase from "@/components/activities/base"
import OwnerLabel from "@/components/activities/owner_label"
import i18n from "@/i18n"

interface UpdatedLayoutProps {
  activity: any
  className?: string
}

const UpdatedLayout = ({ activity, className }: UpdatedLayoutProps) => {
  return (
    <ActivityBase
      data-testid="panel-activity-venue-updated-layout"
      activityKey={activity.key}
      createdAt={activity.createdAt}
      text={i18n.react("app.activities.venue.updated_layout.description", {
        owner: <OwnerLabel owner={activity.owner} />,
      })}
      className={className}
    />
  )
}

export default UpdatedLayout
